


















import { Component, Prop, Vue } from "vue-property-decorator";
import BreadcrumbLinkType from "@/types/BreadcrumbLinkType";

@Component
export default class BreadCrumb extends Vue {
  @Prop() private breadcrumb!: BreadcrumbLinkType[];
}
